var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckOnSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 10,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 12 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.331.579a1.265 1.265 0 0 0-1.86 0L4.258 6.237 2.531 4.412a1.27 1.27 0 0 0-1.849 1.74l3.408 3.64a.23.23 0 0 0 .335-.002l6.906-7.497a1.265 1.265 0 0 0 0-1.714",
  clipRule: "evenodd"
})));
export default SvgCheckOnSwitch;